import { useEffect, useState } from 'react';
import { currentTenantOrNull } from '../tenants';
import { getOrgProfile } from '../api/org-profile';

// Story 065 — Brand name displayed in PWA install copy ("Install <name>").
// For the public tenant this is hardcoded; for white-label tenants we read
// the org profile name (story 064), falling back to the tenant id while the
// fetch is in flight or if the profile name is empty.

const PUBLIC_BRAND = 'Swiss Magic';

export function useBrandName(): string {
  const tenant = currentTenantOrNull();
  const fallback = tenant?.id === 'public' ? PUBLIC_BRAND : tenant?.id ?? PUBLIC_BRAND;
  const [name, setName] = useState<string>(fallback);
  useEffect(() => {
    if (!tenant || tenant.id === 'public') return;
    let cancelled = false;
    getOrgProfile()
      .then((p) => {
        if (cancelled) return;
        const trimmed = p.name?.trim();
        if (trimmed && trimmed.length > 0) setName(trimmed);
      })
      .catch(() => {
        /* fall back to tenant id — not worth surfacing this error */
      });
    return () => {
      cancelled = true;
    };
  }, [tenant?.id]);
  return name;
}
